export default async function deleteRule({ commit, rootGetters, dispatch }, ruleId) {
    try {
        commit('SET_DELETE_RULE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const url = `/proxy/ai/classification-rules?customer_id=${customer_id}&ruleId=${ruleId}`;
        const response = await window.axios.delete(url);

        if (response.data.success) {
            dispatch('notifications/pushNotification', 'Classification rule deleted successfully', { root: true });

            const currentRules = rootGetters["classificationRules/RULES"];
            const updatedRules = currentRules.filter(rule => rule.id !== ruleId);
            commit('SET_RULES', updatedRules);
        } else {
            dispatch('notifications/setError', 'Failed to delete classification rule', { root: true });
        }
    } catch (error) {
        console.error('Error deleting classification rule:', error);
        dispatch('notifications/setError', 'Failed to delete classification rule', { root: true });
    } finally {
        commit('SET_DELETE_RULE_LOADING', false);
    }
}